export function useNavItemExactActive() {
  const route = useRoute()

  function isNavItemExactActive(to) {
    if (!to) return false
    const qIdx = to.indexOf('?')
    const path = qIdx === -1 ? to : to.slice(0, qIdx)
    const queryStr = qIdx === -1 ? '' : to.slice(qIdx + 1)

    if (path !== route.path) return false

    const targetQuery = {}
    if (queryStr) {
      for (const pair of queryStr.split('&')) {
        const eqIdx = pair.indexOf('=')
        const k = decodeURIComponent((eqIdx === -1 ? pair : pair.slice(0, eqIdx)).replace(/\+/g, ' '))
        const v = eqIdx === -1 ? '' : decodeURIComponent(pair.slice(eqIdx + 1).replace(/\+/g, ' '))
        targetQuery[k] = v
      }
    }

    const currentKeys = Object.keys(route.query)
    const targetKeys = Object.keys(targetQuery)
    if (currentKeys.length !== targetKeys.length) return false
    return targetKeys.every((k) => route.query[k] === targetQuery[k])
  }

  return { isNavItemExactActive }
}
